import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Common/Header";
import { Card, Button, Affix, Form, Spin } from "antd";
import { isMobileView } from "../../../Common/AppHelper";
import { useNavigate, useParams } from "react-router-dom";
import { getData } from "../../../../apiServices/common";
import AddPiForm from "./AddPiForm";
import { alertPop } from "../../../../apiServices/common/helper";

export default function EditExportSalesContract(props) {
  // Props
  const { width } = props;

  // States
  const [loading, setLoading] = useState(false);
  const [permitInfo, setPermitInfo] = useState();
  const [piStatus, setPiStatus] = useState();
  const [responseLoading, setResponseLoading] = useState(true);

  // Router
  let { importId } = useParams();
  const navigate = useNavigate();

  // Others
  const propertyFormRef = useRef(null);
  const [form] = Form.useForm();

  const addProduct = () => {
    form.submit();
  };

  const edit_url = `/api/accounting/import-pi/show/${importId}`;
  const getPIInfo = async () => {
    // setResponseLoading(true);
    let res = await getData(edit_url);

    if (res && res?.data?.code == 200) {
      let masterData = res?.data?.data;
      setPermitInfo(masterData);
      setPiStatus(masterData?.status);
    } else {
      alertPop("error", "You cannot update this PI now");
      navigate("/import/pi");
    }
    setResponseLoading(false);
  };

  useEffect(() => {
    getPIInfo();
  }, []);

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="Update Proforma Invoice"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} disabled>
                {piStatus}
              </Button>,
              <Button
                size="small"
                key={2}
                type="primary"
                onClick={() => addProduct()}
                loading={loading}
                disabled={piStatus === "LC_Opened" || responseLoading}
              >
                Update
              </Button>,
            ]}
          />
        </Card>
      </Affix>
      <Spin spinning={responseLoading}>
        <AddPiForm ref={propertyFormRef} permitInfo={permitInfo} form={form} setLoading={setLoading} />
      </Spin>
    </>
  );
}
